import { FC } from 'react';
import styles from '@/components/elems/GlobalLoading/GlobalLoading.module.scss';
import Loading from '@/components/elems/Loading/Loading.component';
import Overlay from '@/components/elems/Overlay/Overlay.component';

const GlobalLoading: FC = () => (
    <Overlay className={`flc ${styles.globalLoadingWrapper}`}>
        <Loading />
    </Overlay>
);

export default GlobalLoading;
